const languagePack = {
    seo: {
        home: {
            title: "ROY GYM Székesfehérvár | Modern Gym & Classes",
            description:
                "Modern gym in Székesfehérvár: Pilates, circuit training, TRX, body sculpting, stretching & mobility, functional workouts, plus personal and group training."
        },
        services: {
            title: "Services | ROY GYM – Classes & Training",
            description:
                "Explore our classes and training: Pilates, circuit training, TRX, body-sculpt, stretching & mobility, functional training and personal training."
        },
        pricelist: {
            title: "Price List | ROY GYM – Passes & Tickets",
            description:
                "Prices for day passes and memberships: monthly, 10-entry, 3/6/12-month, plus student and senior discounts."
        },
        about: {
            title: "About | ROY GYM – Community Gym",
            description:
                "Meet the team behind ROY GYM and our friendly atmosphere. Modern equipment, supportive coaching and training options for all levels."
        },
        news: {
            title: "News | ROY GYM",
            description:
                "Latest updates, events, promotions and news from ROY GYM. Stay in the loop about what’s happening at the gym."
        },
        trainers: {
            title: "Trainers | ROY GYM – Personal Training",
            description:
                "Get to know our personal trainers: profiles, contacts and specialties. Support for weight loss, muscle gain and lifestyle change."
        },
        timetable: {
            title: "Timetable | ROY GYM – Group Classes",
            description:
                "Check the current group class timetable with times and updates. Plan your week and find the right class for you."
        },
        gallery: {
            title: "Gallery | ROY GYM",
            description:
                "Photos from ROY GYM: the facility, equipment and class atmosphere. Take a look before your first visit."
        },
        career: {
            title: "Career | ROY GYM",
            description:
                "Open positions at ROY GYM: personal trainers, cleaners and more. Find details, requirements and how to apply."
        },
        company: {
            title: "Imprint | ROY GYM",
            description:
                "Company and hosting provider details for the ROY GYM website, including contact and legal information."
        },

        // Optional (recommended): noindex these pages
        notfound: {
            title: "404 – Page Not Found | ROY GYM",
            description:
                "The page you’re looking for can’t be found. Please check the URL or return to the homepage."
        },
        error: {
            title: "Something went wrong | ROY GYM",
            description:
                "We couldn’t load this page due to a technical issue. Please try again later or return to the homepage."
        }
    },
    notfound: {
        title: "Oops!",
        message: "This page does not exist!",
        backhome: "Back to homepage"
    },
    error: {
        title: "An error occurred",
        message: "Error message: ",
        backhome: "Back to homepage"
    },
    common: {
        loading: "Loading",
        loadingOptions: [
            "Loading gains…",
            "Racking the plates…",
            "Counting reps…",
            "Shaking the protein…",
            "Wiping the bench…",
            "Adding one more rep for luck…",
            "Chalking up the bar…",
            "Squeezing out the last set…",
            "Refilling the water bottle…",
            "Flexing in the mirror…",
            "Chugging the pre-workout…",
            "Recovery in progress…",
            "Dispensing vitamins…",
            "Cooking the chicken…",
            "Getting ready for leg day…",
            "Pumping the biceps…",
            "Starting superset…"
        ]
    },
    hero: {
        h1: "Modern gym in Székesfehérvár – ROY GYM",
        p: "Pilates, Circuit Training, TRX, Body Sculpting, Stretching & Mobility, Functional workouts, plus personal and group training. Our gym is also equipped with a professional machine park."
    },
    nav: {
        about: "About",
        services: "Services",
        servicesDropdown: {
            pilates: "Pilates",
            koredzes: "Circuit training",
            trx: "TRX",
            alakformalo: "Body-sculpting",
            mobilitas: "Stretching & mobility",
            funkcionalis: "Functional training",
            szemelyiedzes: "Personal training"
        },
        gallery: "Gallery",
        trainers: "Trainers",
        contact: "Contact",
        news: "News",
        pricelist: "Price list",
        timetable: "Timetable",
        career: "Career"

    },
    home: {
        hero: {
            slogen: "Feel like you belong",
            newcomer: "New here?",
            scrollcue: "Scroll down"
        },
        pricelist: {
            title: "Our Offer",
            viewFull: "View full price list"
        },
        services: {
            title: "Browse our services",
            viewFull: "All services"
        },
        trainers: {
            title: "We help you achieve your goals",
            viewFull: "All personal trainers"
        }
    },
    career: {
        title: "Career",
        subtitle: "Join the RoyGym team!",
        intro:
            "We are constantly looking for dynamic, committed colleagues who share our passion for sport and a healthy lifestyle.",
        positionsTitle: "Current opportunities",
        positions: {
            trainer: {
                title: "Personal trainers",
                desc:
                    "We are seeking experienced, motivated professionals who support our guests’ progress; trainers do not receive a separate salary.",
                info:
                    "Important: personal trainers pay no commission or rental fee—the only requirement is that the client has a valid day ticket or pass.",
                exception:
                    "Exception: if the trainer leads a group class that is added to the official timetable, a separate agreement is required."
            },
            cleaner: {
                title: "Cleaners",
                desc:
                    "We are looking for conscientious and reliable colleagues who help maintain the gym’s cleanliness and hygiene standards."
            }
        },
        applyTitle: "Application",
        applyDesc:
            "If you would like to be part of a professional and friendly team, send your CV with a photo to:",
        phoneDesc: "If you have any questions, feel free to call us:"
    },
    news: {
        title: "News",
        loading: "Loading news...",
    },
    timetable: {
        title: "Timetable",
        loading: "Loading timetable..."
    },
    pricelist: {
        title: "Price List",
        sections: {
            adult: {
                title: "Adult Passes and Tickets",
                items: [
                    { name: "Day Pass", price: "2 000 Ft", desc: "Valid for a single entry, includes full gym access for the day." },
                    { name: "Monthly Pass", price: "17 000 Ft", desc: "Valid for 30 days with unlimited gym access." },
                    { name: "10-Entry Pass", price: "17 000 Ft", desc: "Valid for 60 days with a total of 10 entries." },
                    { name: "3-Month Pass", price: "46 000 Ft", desc: "Valid for 90 days with unlimited access." },
                    { name: "6-Month Pass", price: "88 000 Ft", desc: "Valid for 180 days with unlimited access." },
                    { name: "12-Month Pass", price: "166 900 Ft", desc: "Full-year pass, best value for daily training." },
                ]
            },
            discount: {
                title: "Student and Pensioner Passes",
                items: [
                    { name: "Day Pass", price: "2 000 Ft", desc: "Valid for a single entry." },
                    { name: "Monthly Pass", price: "14 000 Ft", desc: "30 days of unlimited access at a discounted rate." },
                    { name: "10-Entry Pass", price: "14 000 Ft", desc: "Valid for 60 days with 10 entries." },
                    { name: "3-Month Pass", price: "36 000 Ft", desc: "Valid for 90 days with unlimited access." },
                    { name: "6-Month Pass", price: "71 000 Ft", desc: "Valid for 180 days, anytime use." },
                    { name: "12-Month Pass", price: "138 000 Ft", desc: "Valid for 360 days, full-year discounted access." }
                ]
            },
            group: {
                title: "Group Class",
                items: [
                    { name: "Single Class Ticket", price: "3 000 Ft", desc: "Valid for one group class." },
                    { name: "5-Class Pass", price: "13 500 Ft", desc: "Valid for 30 days, 5 group classes." },
                    { name: "10-Class Pass", price: "27 000 Ft", desc: "Valid for 60 days, 10 group classes." }
                ],
                note: [
                    "Group passes include gym access before and after class.",
                    "Please bring your pass each time – one session is deducted automatically.",
                    "Pre-registration is required to reserve a spot."
                ]
            },
        },
        footer: "All prices are in HUF and include VAT.",
        specialDiscount: "Special Discount!",
    },
    services: {
        title: "Services",

        pilates: {
            name: "Pilates",
            desc:
                "Pilates is a deep-core-strengthening, slow-paced exercise method that focuses on the stabilising muscles of the trunk, posture and breathing. It is an excellent choice if you want to strengthen your abdominal and back muscles, improve your posture, ease lower-back or back pain and recharge mentally. Suitable for beginners and advanced alike, it is gentle yet very effective."
        },

        koredzes: {
            name: "Circuit Training",
            desc:
                "Circuit training is an efficient and varied form of exercise in which you perform several drills one after another at different stations. It combines strength and endurance development, improves body composition, accelerates metabolism and boosts fat burning. Because it is always varied, it never becomes boring, and it can be started at any fitness level."
        },

        cardiowalk: {
            name: "Cardiowalk",
            desc:
                "Cardiowalk is a unique, dynamic workout that fuses the power of brisk walking with rhythmic music. During the class we work with inclines, varying tempos and continuous coaching cues to increase fat burning, shape the lower-body muscles and improve endurance. The workout is especially suitable for those who dislike jumping or overly strenuous movements but still want an effective, lively and joint-friendly exercise experience."
        },

        trx: {
            name: "TRX",
            desc:
                "TRX is a suspension-training tool that lets us perform body-weight exercises. It excels at developing core stability, strength, balance and coordination. A major advantage is that intensity can be adjusted easily, so both beginners and advanced participants will find the right level of challenge."
        },

        alakformalo: {
            name: "Body-Sculpt",
            desc:
                "Our body-sculpt class targets typical female problem areas: abs, thighs, glutes and arms. Throughout the session we alternate strengthening and fat-burn blocks, effectively shaping the figure and increasing firmness. It is an ideal choice if you want a more toned body and better overall wellbeing."
        },

        mobilitas: {
            name: "Stretching & Mobility",
            desc:
                "Stretching and mobility are crucial for a healthy range of motion and injury prevention. In these classes, besides improving flexibility, we help you unwind, release muscle stiffness and enhance body awareness. They are also recommended as a complement to other workouts."
        },

        funkcionalis: {
            name: "Functional Training",
            desc:
                "This training style is built on everyday movement patterns – squatting, lifting, pulling, pushing – and boosts the body’s overall performance. We work with body weight, dumbbells, kettlebells or other equipment. It develops strength, endurance, coordination and balance – a genuine full-body workout."
        },

        szemelyiedzes: {
            name: "Personal Training",
            desc:
                "If you prefer individual attention, our personal training helps you reach your goals – whether weight loss, muscle gain, rehabilitation or a lifestyle change. The sessions are tailored entirely to you, and we accompany you throughout your progress. Your chosen trainer will be at your side every step of the way."
        }
    },
    about: {
        title: "About us",
        intro: "Step inside our gym—strength is forged not only in muscle but also in community.",
        team: "We are Roland and Daniella, two devoted enthusiasts who turned our passion for sport and people into this haven. By opening its doors, we envisioned a place that feels like home to every visitor—rookie or veteran, youthful or seasoned.",
        familyAtmosphere: "A family atmosphere here is no mere slogan; guests are welcomed by name, cared for with genuine attention, and supported whether they're seeking a lifestyle shift, weight loss, greater strength, or simply a stress-free way to move.",
        groupClasses: "A colourful schedule of group classes awaits: fat-burning circuits, power-building sessions, mobility flows, and revitalising, energy-boosting workouts—so everyone can discover a perfect fit.",
        membership: "Discounted passes make regular attendance easy, while drop-in options keep things flexible, letting each member shape training around personal schedules and goals.",
        philosophy: "Because training sculpts spirit as much as body, we cultivate a motivating, friendly, inspiring environment where anyone can cross the threshold with confidence—free from prejudice and pressure.",
        invitation: "Pay us a visit, take a trial session, get acquainted, and join a supportive community that journeys toward your goals together."
    },
    gallery: {
        title: "Gallery",
        loading: "Loading gallery..."
    },
    trainers: {
        title: "Trainers",

        /* Labels reused in every profile */
        labels: {
            phone: "Phone",
            email: "E-mail",
            instagram: "Instagram"
        },

        /* ----------------------------------------------------------------
           Individual trainers
        ----------------------------------------------------------------- */
        list: {
            // janika: {
            //     name: "Deme János",
            //     phone: "+36 20 373 4111",
            //     email: "demejani@icloud.com",
            //     instagram: "@deme_jani",
            //     bio: "Hi, I'm János Deme.\n\nI started weight training 10 years ago and it has become an integral part of my life. Out of those, I spent 3 years competing and 3 years coaching competitors.\n\n🏆 Wabba Junior BB 🥇\n🏆 Wabba Athletic BB 🥇\n🏆 Wabba Short BB 🥇\n\nIn 2021 I graduated from the IWI International Fitness School, specializing in Sports Instruction, Bodybuilding & Fitness, and Contest Prep.\n\nI have been working full-time as a coach for 4 years. I train anyone who wants to exercise, regardless of age, goal or gender. As a contest-prep coach I’ve achieved great results with my athletes, all the way up to gold medals — be the next!\n\n💰 *Training prices*\n• Personal training: 5 000 Ft / session\n• Duo training: 3 500 Ft / person / session\n\n8-session pass: 35 000 Ft\n10-session pass: 40 000 Ft\n12-session pass: 45 000 Ft\nStudents save 5 000 Ft!\n\n*Nutrition plan*\n20 000 Ft • 15 000 Ft for pass-holders\n\nI’ll show you the way — walk it and you’ll reach your goal!\n\nGet in touch by message or phone."
            // },

            roland: {
                name: "Fehér Roland",
                phone: "+36 30 491 9340",
                email: "apika89305@gmail.com",
                instagram: "@fit_by_roy",
                image: "roland.jpg",
                bio: "Hi! I'm Roland Fehér, owner of Roy Gym.\n\nEntrepreneur, personal and group trainer and competitor for 10 years. Those who know me are aware that coaching is not work for me but a calling — my whole life is built around it mentally, physically and spiritually.\n\nI owe my successes to putting my clients' goals first and guiding them accordingly to the best of my knowledge. I want to help as many people as possible live a healthy lifestyle and offer an escape from the rush of everyday life.\n\n────────────────────────────\n💡 *What can I offer?*\n\n• **Lifestyle and nutrition coaching** – tailor-made meal structures, recipes and hacks adapted to your daily routine for long-term progress.\n\n• **Personal training** (5 000 Ft / session) – 1-on-1, 60 minutes of undivided attention, tuned to you and your goals after an initial assessment. Pilates and TRX options.\n\n• **Duo training** (3 500 Ft / person / session) – for friends, couples, family members. A 60-minute class with easy-to-follow yet dynamic shared tasks.\n\n• **Group training** (2 500 Ft / person / session) – circuit training with several stations: dumbbells, TRX, resistance bands, step-board, unstable equipment etc. Suitable for beginners and advanced alike.\n\nLet’s start the journey of change together and create something lasting that will accompany you throughout your life! 🙏\n\nMessage me or call +36 30 491 9340.\nE-mail: apika89305@gmail.com\nInstagram: @fit_by_roy"
            },

            daniella: {
                name: "Bakos Daniella",
                phone: "+36 30 959 2613",
                email: "mailto:daniellabakos6@gmail.com",
                instagram: "https://instagram.com/daniella_bakos",
                image: "daniella.jpg",
                bio:
                    "Hi!\n\n" +
                    "I'm Daniella Bakos, a personal and partner trainer and the owner of Roy Gym.\n" +
                    "Bodybuilding has been part of my life for 6 years, and for the past 3 years I've been competing in the bikini fitness category with strong results.\n" +
                    "For me this isn’t just a sport—it’s my lifestyle, my passion that runs through my everyday life. And that’s exactly what I want to pass on to you: so you can find your own strength, your confidence, and enjoy how your body—and your whole life—can change.\n\n" +
                    "I don’t believe in one-size-fits-all plans. I work with everyone as if I were working for my own goals: I pay attention to you, listen to your body, your mind and your thoughts, and tailor the program completely to you—so training won’t be a dreaded \"have to\" routine, but an experience that shapes you, energizes you, and improves the relationship you have with yourself.\n\n" +
                    "What you can get from me:\n" +
                    "– Lifestyle & nutrition coaching\n" +
                    "Real, sustainable solutions—not yet another \"miracle diet\".\n" +
                    "Tasty, budget- and time-friendly recipes, practical tips and small tricks that fit not only your life, but your family’s everyday routine too.\n\n" +
                    "– Personal training – 6.000 Ft / session\n" +
                    "For 60 minutes, my focus is only on you. Whether your goal is shaping, strength or recovery, every move serves your goals.\n\n" +
                    "– Partner training – 3.000 Ft / person / session\n" +
                    "If you’d like someone by your side who believes in you even when you doubt yourself—I’m here!\n" +
                    "You can train with a friend, your partner, or even with your parent/child, and I guarantee every session will be motivating, full of good vibes and a great experience.\n\n" +
                    "At first we only take one hour out of your day—but that one hour can change your whole life. As time goes on, you’ll become stronger, more confident and more energetic. If you want to step out of the everyday routine for an hour, focus on yourself, transform, and actually enjoy the process, feel free to reach out—and let’s start together!\n\n" +
                    "8000 Székesfehérvár, Budai út 154.\n" +
                    "Roy GYM training studio",
            },

            eszter: {
                name: "Pataki Eszter",
                phone: "+36 70 380 9749",
                email: "f.patakieszter@gmail.com",
                instagram: "",
                image: "eszter.jpg",
                bio: "I am Eszter Ferkócza Pataki. \n\nI graduated in Human Resource Organization at the Faculty of Science of the University of Pécs.\n\nMy whole life has been filled with a love for sports. As a child, I practiced ballet, then rode horses for many years. Body-shaping and group fitness classes have become a part of my life, which is why I became a certified fitness instructor. Three years ago, I discovered TRX training and made it part of my daily routine. Now, as a qualified TRX trainer, I conduct training sessions myself. \n\nI believe that alongside sport, healthy nutrition is also important, as exercise and nutrition together are the most effective. As a nutrition consultant, I am happy to help in this area too. In both my group and individual sessions, my focus is on variety, enjoyment, and the possible prevention of injuries. \n\nMy motto: Beauty comes from within. \n\nGroup class: 2,500 HUF \n\nIndividual training: 4,000 HUF/hour \n\nIndividual training for 2 people: 3,000 HUF/person"
            },

            reka: {
                active: false,
                name: "Böröcz Réka",
                phone: "+36 30 974 9780",
                email: "mailto:torzsokreka@gmail.com",
                instagram: "https://instagram.com/rk.fitzone",
                image: "reka.jpeg",
                bio: "Réka Böröcz – Fitness Instructor, Postnatal Trainer\n\nI believe movement shapes not only the body but the mind as well. As a postnatal trainer, I place special emphasis on postpartum rehabilitation, and my main goal is to help mothers return to exercise safely, gradually and with confidence.\n\nI want to dispel the fears and misconceptions—especially common among women—about strength training and show that developing strength doesn’t just change your appearance; it makes everyday life more confident, energetic and balanced.\n\nAs a woman and a mother I know how challenging it is to make time for ourselves, so in my sessions I prioritize effectiveness, safety and a positive atmosphere. Whether it’s postpartum recovery, bodyweight, TRX or weight training, everyone will find their own pace and the joy of progress with me.\n\nPersonal training: 5,000 HUF/session\nPartner training: 3,500 HUF/person/session"
            },

            rita: {
                active: false,
                name: "Szalai Rita",
                phone: "+36 30 293 6002",
                email: "rszalai1@gmail.com",
                instagram: "",
                image: "rita.jpg",
                bio: "Hi, I'm Rita Szalai — group instructor, functional trainer and lifestyle coach.\n\nExercise has been part of my life since childhood: I danced for 13 years and later tried aerobics and many other forms of movement. In recent years I’ve fallen in love with functional training and crossfit — they not only shape the body but eliminated my back pain and offset my desk job.\n\n**Qualifications**\n• Lifestyle and nutrition consultant (2020)\n• Functional trainer (2022)\n• Group fitness instructor\n\nI continuously educate myself, especially on hormonal balance, food intolerances and special diets (vegetarian, gluten-free).\n\n**How I can help**\n• Nutrition counselling, support for lifestyle change\n• Alternative diets for food intolerances\n• Support for vegetarian lifestyle (I eat that way too)\n• Functional and TRX workouts\n• Developing endurance and strength\n• Creating physical-mental balance\n\n**Prices**\n• Personal training – 5 000 Ft / session (with full attention)\n• Duo training – 3 500 Ft / person / session\n• Group training – 2 500 Ft / person / session\n\nMessage me or call +36 30 293 6002.\nE-mail: rszalai1@gmail.com"
            },

            mark: {
                name: "Kardos Márk",
                phone: "+36 20 313 8676",
                email: "mailto:markkardos.99@gmail.com",
                instagram: "https://instagram.com/kardosmark",
                image: "mark.jpg",
                bio: "I am Márk Kardos, personal trainer and bodybuilding-fitness sports instructor.\n\nSport has been part of my life since I was 12 years old. I chose the coaching profession because I want to help others become healthier, stronger, and more confident.\n\nEvery training session is tailored to individual goals. Up-to-date knowledge, a motivating atmosphere, and a supportive approach await you every time.\nIf you want to improve and enjoy yourself along the way, I look forward to seeing you!\n\nContact:\nPhone: +36 20 313 8676\nInstagram: kardosmark\nEmail: markkardos.99@gmail.com"
            },

            kristof: {
                active: false,
                name: "Kuncz Kristóf",
                phone: "+36 30 870 3980",
                email: "mailto:kunczkristof.trainer@gmail.com",
                instagram: "https://instagram.com/kuncz.kristof",
                image: "kristof.jpg",
                bio: "Hi, I'm Kristóf Kuncz.\n\nAfter more than 10 years of training experience, I finally started coaching.\n\nI always approach training so that the time and energy invested are fully returned in results. In recent years I have continually educated myself to provide up-to-date knowledge and experience to those who ask for my help.\n\nHow can I help you?\n\n• personal training\n• customized workout plan\n• nutrition coaching\n• meal plan creation\n\nTraining prices\n• Personal training: 5,000 HUF/session\n• Partner training: 3,500 HUF/person/session\n\nPass prices\n• 8-session pass: 35,000 HUF\n• 12-session pass: 50,000 HUF\n\nReady to make a change? It’s time to reach your goals!\nContact me today and let’s start your transformation!\n\nInquire by phone, on social media, or by email!"
            },

            istvan: {
                name: "Molnár István Márk",
                phone: "+36 20 482 4694",
                email: "mailto:molnaredzo@gmail.com",
                instagram: "https://instagram.com/mlnr_istvan",
                image: "istvan.jpg",
                bio: "Recreational boxing coach. I offer recreational boxing sessions, personalized workout plans, endurance and strength development, plus support with technique and nutrition."
            },
            balazs: {
                name: "Csata Balázs",
                phone: "+36 70 414 8877",
                email: "mailto:csatabalazs911@gmail.com",
                instagram: "https://instagram.com/balazs.csata",
                image: "balazs.jpg",
                bio: "Personal trainer. I help you reach your goals through individual and partner training, personalized workout plans, nutrition counselling and meal-plan preparation."
            }
        }
    },
    company: {
        title: "Imprint",
        sectionTitle: "Company and Hosting Provider Information",
        businessTitle: "Business Information",
        businessName: "Company Name",
        address: "Registered / Postal Address",
        taxNumber: "Tax Number",
        regNumber: "Registration Number",
        phone: "Phone Number",
        email: "E-mail",
        bankAccount: "Bank Account Number",
        hostingTitle: "Hosting Provider Information",
        hostingName: "Company Name",
        hostingAddress: "Address"
    },
    footer: {
        contactTitle: "Contact",
        hoursTitle: "Opening Hours",
        hoursWeek: "Mon – Fri: 6 am – 10 pm",
        hoursWeekend: "Sat – Sun: 8 am – 8 pm",
        followTitle: "Follow Us",
        address: "Budai Road 154, Székesfehérvár",
        impresszumTitle: "Imprint",
        creditPrefix: "Designed and created by",
        creditName: "Clarity Works"
    },

}

export default languagePack
